import { profileConstants,editProfileConstants } from '../Constants';
import { adminUsersServices } from '../Services';

export const profileActions = {
    profileModules,
    EditProfile
};

function profileModules(data: any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: profileConstants.SEARCH_PROFILE_REQUEST,
            data: null
        }));
        adminUsersServices.profileModules(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: profileConstants.SEARCH_PROFILE_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: profileConstants.SEARCH_PROFILE_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: profileConstants.SEARCH_PROFILE_FAILURE,
                        data:  error.message
                    }));
                }
            );
    };
}


function EditProfile(data:any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: editProfileConstants.EDIT_PROFILE_REQUEST,
            data: null
        }));
        adminUsersServices.editProfile(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: editProfileConstants.EDIT_PROFILE_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: editProfileConstants.EDIT_PROFILE_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: editProfileConstants.EDIT_PROFILE_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}



function dispatchFunction(data: any) {
    // To do: check for refresh / unauthorized error
    return {
        type: data.type,
        data: data.data
    };
}